import { TransferSearch } from '@p2p/entities/payment';
import { CheckUserPage } from '@p2p/pages/CheckUser';
import DisputePayment from '@p2p/pages/Disputes';
import { NotFoundErrorPage, ServerErrorPage } from '@p2p/pages/Errors';
import LandingRenderContent from '@p2p/pages/LandingRenderContent';
import { MatchingDetailsPayment } from '@p2p/pages/MatchingDetailsPayment';
import { CreateRequisitePage, MatchingPayment, SelectAmountPage } from '@p2p/pages/MatchingPayment';
import { TransferFormPage } from '@p2p/pages/Payment/components/TransferForm/TransferFormPage';
import { TransferInvoicePage } from '@p2p/pages/Payment/components/TransferInvoicePage';
import { PaymentSuccessPage } from '@p2p/pages/PaymentSuccessPage';
import { PaymentWarningPage } from '@p2p/pages/PaymentWarning';
import { ProofDetailsPayment, ProofPayment } from '@p2p/pages/ProofPayment';
import { TransferCanceledPage } from '@p2p/pages/TransferCanceled';
import { TransferRequestSuccessPage } from '@p2p/pages/TransferRequestSuccess';
import { MSP_PAGE, NOT_FOUND_PAYMENT, PROOF_PAGE } from '@p2p/shared/constants';
import { routes } from '@p2p/shared/routing';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { ErrorPaymentPage } from './pages/ErrorPaymentPage';

const RedirectPage = lazy(() =>
  import('@p2p/pages/Redirect').then((module) => ({ default: module.RedirectPage })),
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path={routes.disputePayment.template} element={<DisputePayment />} />
        <Route path={routes.transfer.template} element={<LandingRenderContent />}>
          <Route path={routes.transferCanceled.template} element={<TransferCanceledPage />} />
          <Route path={routes.transferSearch.template} element={<TransferSearch />} />
          <Route path={routes.transferInvoice.template} element={<TransferInvoicePage />} />
          <Route path={routes.transferBank.template} element={<TransferFormPage />} />
        </Route>
        <Route path={routes.notFoundError.template} element={<NotFoundErrorPage />} />
        <Route path={routes.serverError.template} element={<ServerErrorPage />} />
        <Route
          path={routes.redirect.template}
          element={
            <Suspense fallback={null}>
              <RedirectPage />
            </Suspense>
          }
        />
        <Route path={`${MSP_PAGE}/:id`} element={<MatchingPayment />}>
          <Route path="check-user" element={<CheckUserPage />} />
          <Route index element={<SelectAmountPage />} />
          <Route path="details" element={<MatchingDetailsPayment />} />
          <Route path="create-requisite" element={<CreateRequisitePage />} />
          <Route path="search" element={<TransferSearch />} />
          <Route path="dispute" element={<PaymentWarningPage />} />
          <Route path="dispute/success" element={<TransferRequestSuccessPage />} />
          <Route path="success" element={<PaymentSuccessPage />} />
          <Route path="canceled" element={<TransferCanceledPage />} />
        </Route>
        {/* P2P-2880: пополнение с обязательной загрузкой PDF-чека (payment_form = proof_page). */}
        <Route path={`${PROOF_PAGE}/:id`} element={<ProofPayment />}>
          <Route index element={<ProofDetailsPayment />} />
          <Route path="check-user" element={<CheckUserPage />} />
          <Route path="search" element={<TransferSearch />} />
          <Route path="dispute" element={<PaymentWarningPage />} />
          <Route path="dispute/success" element={<TransferRequestSuccessPage />} />
          <Route path="success" element={<PaymentSuccessPage />} />
          <Route path="canceled" element={<TransferCanceledPage />} />
        </Route>
        <Route path={`/:id/${NOT_FOUND_PAYMENT}`} element={<ErrorPaymentPage />} />
        <Route path="*" element={<NotFoundErrorPage />} />
      </Routes>
    </Router>
  );
};

export default App;
